import * as React from "react";
import { SingleColumnDropdown } from "@grandvisionhq/forms";
import { FacetPickerHeader } from "../../../../../../components/modules/EcommContent/components/FacetPickers/components/FacetPickerHeader.js";
import { useGetProductLinkFormatter } from "../../../../../hooks/modules/EcommContent/components/FacetPickers/FacetPickerDropdown/hooks/use-get-product-link-formatter.js";
/* empty css                         */
const FacetPickerDropdown = ({
  title,
  rightSlot,
  activeFacet,
  items,
  productType,
  onPick
}) => {
  const productLinkFormatter = useGetProductLinkFormatter();
  const selectedValue = activeFacet.facetTerm;
  const mappedOptions = React.useMemo(
    () => Object.entries(items).reduce(
      (acc, [_, item]) => ({ ...acc, [item.facetTerm]: item.facetTerm }),
      {}
    ),
    [items]
  );
  const handleSelect = (newValue) => {
    const selectedItem = items.find((item) => item.facetTerm === newValue);
    if (!selectedItem) return;
    const href = productLinkFormatter(selectedItem.slug, selectedItem.sku, productType);
    onPick({
      sku: selectedItem.sku,
      facetTerm: selectedItem.facetTerm,
      name: selectedItem.name,
      href
    });
  };
  return /* @__PURE__ */ React.createElement("div", { className: "facet-picker-dropdown" }, /* @__PURE__ */ React.createElement(FacetPickerHeader, { rightSlot }, title), /* @__PURE__ */ React.createElement(
    SingleColumnDropdown,
    {
      label: title,
      selectedValue,
      onChange: handleSelect,
      options: mappedOptions,
      "data-t": "power-dropdown"
    }
  ));
};
export {
  FacetPickerDropdown
};
//# sourceMappingURL=FacetPickerDropdown.js.map
